// Soft marimba-style chimes for the farm journey, synthesised with the Web Audio
// API so there are no audio files to load. Browsers only allow audio after a
// click or tap, so unlockAudio() must be called from a click handler.

// C major pentatonic, rising one note per milestone.
const NOTES = [523.25, 587.33, 659.25, 783.99, 880.0, 1046.5]

let ctx = null

// Resolves true once audio can play, false if the browser has no Web Audio.
export const unlockAudio = () => {
    const AudioCtx = window.AudioContext || window.webkitAudioContext
    if (!AudioCtx) return Promise.resolve(false)
    if (!ctx) ctx = new AudioCtx()
    return ctx.resume().then(() => true, () => false)
}

// A sine fundamental plus a quick-fading overtone at 4x, which gives the
// wooden "tok" of a marimba bar.
const pluck = (freq, at, peak) => {
    const partials = [[1, peak, 0.9], [4, peak * 0.18, 0.15]]
    partials.forEach(([mult, level, decay]) => {
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.type = 'sine'
        osc.frequency.value = freq * mult
        gain.gain.setValueAtTime(0.0001, at)
        gain.gain.exponentialRampToValueAtTime(level, at + 0.008)
        gain.gain.exponentialRampToValueAtTime(0.0001, at + decay)
        osc.connect(gain).connect(ctx.destination)
        osc.start(at)
        osc.stop(at + decay + 0.05)
    })
}

export const playMilestone = (i, total) => {
    if (!ctx || ctx.state !== 'running') return
    const t = ctx.currentTime
    pluck(NOTES[i % NOTES.length], t, 0.12)
    // A small resolving chord when the line reaches the last step.
    if (i === total - 1) {
        pluck(NOTES[0], t + 0.12, 0.06)
        pluck(NOTES[2], t + 0.12, 0.06)
        pluck(NOTES[NOTES.length - 1] * 2, t + 0.24, 0.04)
    }
}
